import { Dispatch, ReactElement } from 'react';
import {CurrentUser, CustomerGearResponse, CustomerProfile, GearFilters} from 'types';
import { formatNumberToLetteredValue } from 'utils/formatters';
import { SnackbarProps } from 'components/Snackbar';
import { ListingsTab, SharesTab, FollowersTab, FollowingTab, AboutTab } from './Tabs';

export type TabProps = {
  username: string;
  user?: CurrentUser;
  profile: CustomerProfile;
  setSnackbarMessage: Dispatch<SnackbarProps | null>;
  toggleFavorite: (slug: string, isFavorite: boolean) => Promise<boolean>;
  onShare: (slug: string, owner: Partial<CustomerProfile>, isSold: boolean) => void;
  onComment: (slug: string) => void;
  listingData: CustomerGearResponse;
  filters: GearFilters;
  setActiveTab: Dispatch<TabType>;
};

export type TabType = 'listings' | 'shares' | 'followers' | 'following' | 'about';

export type TabMapTab = {
  label: string;
  counter?: (profile: CustomerProfile) => any;
  tab: (props: TabProps) => ReactElement;
};

export type Tab = TabMapTab & {
  id: TabType;
};

export type TabMap = {
  [Property in TabType]: TabMapTab;
};

const tabsMap: TabMap = {
  listings: {
    label: 'Listings',
    counter: (profile: CustomerProfile) => formatNumberToLetteredValue(+(profile.listings || 0)),
    tab: (props: TabProps) => <ListingsTab {...props} />,
  },
  shares: {
    label: 'Shares',
    counter: (profile: CustomerProfile) => formatNumberToLetteredValue(profile.shares_count),
    tab: (props: TabProps) => <SharesTab {...props} />,
  },
  followers: {
    label: 'Followers',
    counter: (profile: CustomerProfile) => formatNumberToLetteredValue(profile.followers_count),
    tab: (props: TabProps) => <FollowersTab {...props} />,
  },
  following: {
    label: 'Following',
    counter: (profile: CustomerProfile) => formatNumberToLetteredValue(profile.following_count),
    tab: (props: TabProps) => <FollowingTab {...props} />,
  },
  about: {
    label: 'About',
    tab: (props: TabProps) => <AboutTab {...props} />,
  },
};

export const tabs = Object.entries(tabsMap).map(
  ([id, tab]): Tab => ({
    id: id as TabType,
    ...tab,
  }),
);

export default tabsMap;
